import React from "react"

import Image from "../components/image"
import Social from "../components/social"
import ModeSwitcher from "../components/modeSwitcher"

const Sidebar = () => (
  <section>
    <div>
      <div className="text-center">
        <div>
          <Image />
        </div>
        <div className="my-3 ">Electronics Engineer</div>
        <ModeSwitcher></ModeSwitcher>
        <div>
          <Social></Social>
        </div>
      </div>
    </div>
  </section>
)

export default Sidebar
